export type RosterType = 'OVERWATCH_PRO' | 'OVERWATCH_ACADEMY' | 'MARVEL_RIVALS' | 'POKEMON_VGC' | 'POKEMON_UNITE' | 'DOFUS';

export const RosterTypeList: RosterType[] = [
	'OVERWATCH_PRO',
	'OVERWATCH_ACADEMY',
	'MARVEL_RIVALS',
	'POKEMON_VGC',
	'POKEMON_UNITE',
	'DOFUS'
];
